export default {
  watchVideo: 'Ver vídeo',
  foundation: 'Fundamentación',
  pedagogicalObjective: 'Objetivos pedagógicos',
  resources: 'Recursos que conforman este programa',
  showMore: 'Ver más',
  downloadLink: 'Detalle de programa',
  addProgram: 'Agregar programa a mi licencia',
  askInfo: 'Solicitar información',
  workingOnEducationalProgram: 'Estamos trabajando en este Programa Educativo',
  comingSoon: 'Estará disponible muy pronto',
  interested: '¿Te interesa conocer más de esta propuesta?',
  earlyInformation: 'Pídenos información anticipadamente',
  knowMore: '¡Quiero saber más!',
  ods: 'Este programa promueve los siguientes ODS',
  category: {
    computationalThinking: 'Pensamiento computacional',
    globalCitizenship: 'Ciudadanía global',
    entrepreneurialSpirit: 'Espíritu emprendedor',
    teachersTraining: 'Acompañamiento docente'
  },
  redirection: 'El programa educativo no se encuentra en el idioma seleccionado, pero lo puedes ver en ',
  and: 'y',
  seeRegister: 'Ver registro de uso',
  registerUse: 'Registrar uso',
  udls: 'Pautas DUA',
  levelLabel: 'Nivel',
  gradeLabel: 'Año',
  downloadPdfSummary: 'Descargar resumen global en PDF',
  levelLabel: 'Nivel y año'
}

export const en = {
  watchVideo: 'Watch video',
  foundation: 'Rationale',
  pedagogicalObjective: 'Educational goals',
  resources: 'Resources that make up this program',
  showMore: 'Show more',
  downloadLink: 'Program details',
  addProgram: 'Add program to my license',
  askInfo: 'Request information',
  workingOnEducationalProgram: 'We\'re working on this Educational Program',
  comingSoon: 'It\'ll be available soon',
  interested: 'Do you want to find out more about this proposal?',
  earlyInformation: 'Ask us for information in advance',
  knowMore: 'I want to find out more!',
  ods: 'This program promotes the following SDGs',
  category: {
    computationalThinking: 'Computational thinking',
    globalCitizenship: 'Global citizenship',
    entrepreneurialSpirit: 'Entrepreneurial spirit',
    teachersTraining: 'Teacher guidance'
  },
  redirection: 'The educational program is not available in the selected language, but you can see it in ',
  and: 'and',
  seeRegister: 'View usage record',
  registerUse: 'Register usage',
  downloadPdfSummary: 'Download global summary in PDF',
  udls: 'UDL Guidelines',
  levelLabel: 'Level and Year'
}

export const ca = {
  watchVideo: 'Reprodueix el vídeo',
  foundation: 'Fonament',
  pedagogicalObjective: 'Objectius pedagògics',
  resources: 'Recursos que conformen aquest programa',
  showMore: 'Ensenya\'m més',
  downloadLink: 'Detall del programa',
  addProgram: 'Afegir programa a la meva llicència',
  askInfo: 'Sol·licitar informació',
  workingOnEducationalProgram: 'Estem treballant en aquest Programa Educatiu',
  comingSoon: 'Estarà disponible molt aviat',
  interested: 'T\'interessa conèixer més d\'aquesta proposta?',
  earlyInformation: 'Demana\'ns informació anticipadament',
  knowMore: 'Vols saber-ne més?',
  ods: 'Aquest programa fomenta els següents ODS',
  category: {
    computationalThinking: 'Pensament computacional',
    globalCitizenship: 'Ciutadania global',
    entrepreneurialSpirit: 'Esperit emprenedor',
    teachersTraining: 'Acompanyament docent'
  },
  redirection: 'El programa educatiu no es troba en l\'idioma seleccionat, però el pots veure en ',
  and: 'y',
  seeRegister: 'Veure registre d\'ús',
  registerUse: 'Registrar ús',
  downloadPdfSummary: 'Baixar resum global en PDF',
  udls: 'Pautes DUA',
  levelLabel: 'Nivell i any'
}
